/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_CutInputs */

const en_portal_goal_cut = /** @type {(inputs: Portal_Goal_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cut`)
};

const pl_portal_goal_cut = /** @type {(inputs: Portal_Goal_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redukcja`)
};

/**
* | output |
* | --- |
* | "Cut" |
*
* @param {Portal_Goal_CutInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_cut = /** @type {((inputs?: Portal_Goal_CutInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_CutInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_cut(inputs)
	return en_portal_goal_cut(inputs)
});